import { Dismiss } from 'flowbite';

function initializeFlashMessages() {
  // Handle notice messages (success)
  const flashNotice = document.getElementById('flash-notice');
  if (flashNotice) {
    const noticeDismiss = new Dismiss(flashNotice, null, {
      transition: 'transition-opacity',
      duration: 300,
      timing: 'ease-out',
      onHide: (context, targetEl) => {
        targetEl.remove();
      }
    });

    // Auto hide after 3 seconds
    setTimeout(() => {
      noticeDismiss.hide();
    }, 3000);
  }

  // Handle alert messages (errors)
  const flashAlert = document.getElementById('flash-alert');
  if (flashAlert) {
    const alertDismiss = new Dismiss(flashAlert, null, {
      transition: 'transition-opacity',
      duration: 300,
      timing: 'ease-out',
      onHide: (context, targetEl) => {
        targetEl.remove();
      }
    });

    // Auto hide after 5 seconds (longer for error messages)
    setTimeout(() => {
      alertDismiss.hide();
    }, 5000);
  }
}

// Initialize on both DOMContentLoaded and Turbo navigation
document.addEventListener('DOMContentLoaded', initializeFlashMessages);
document.addEventListener('turbo:load', initializeFlashMessages);
document.addEventListener('turbo:render', initializeFlashMessages); 